import { render, staticRenderFns } from "./CompanySkillsSection.vue?vue&type=template&id=1023e7e0&scoped=true&"
import script from "./CompanySkillsSection.vue?vue&type=script&lang=js&"
export * from "./CompanySkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./CompanySkillsSection.vue?vue&type=style&index=0&id=1023e7e0&lang=scss&scoped=true&"
import style1 from "./CompanySkillsSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023e7e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkillsInventoryFinder: require('/workspace/components/SkillsInventory/Filters/SkillsInventoryFinder.vue').default})
